module.exports = __webpack_public_path__ + "img/TV_clean_box16.64d4bfd4.jpg";